/*
 * @Descripttion:
 * @version:
 * @Author: guoye
 * @Date: 2023-10-19 16:38:45
 * @LastEditors: guoye
 * @LastEditTime: 2025-07-14 18:06:19
 */
import { sm2, sm3 } from 'sm-crypto'

const TIMESTAMP = 'timestamp'

const Encrypt = {
  sm2(textString) {
    return (
      '04' +
      sm2.doEncrypt(textString, Storage.getStorage('pinia_global').pina_env_var?.SM2_PUBLICK_KEY, 1).toUpperCase()
    )
  },
  sm3,
}

const Decrypt = {
  sm2(encryptData) {
    if (encryptData && encryptData?.startsWith('04')) {
      encryptData = encryptData?.substring(2)
      return sm2.doDecrypt(encryptData, Storage.getStorage('pinia_global').pina_env_var?.SM2_PRIVATE_KEY, 1)
    }
  },
}

function encryptRequest(payload, isTs, extraSignPayload) {
  // timestamp
  const ts = Date.now().toString()

  //   const signData = {}
  //   for (const key in payload) {
  //     if (Object.hasOwnProperty.call(payload, key)) {
  //       const val = payload[key]
  //       if (val !== '' && val !== undefined && val !== null) {
  //         signData[key] = val
  //       }
  //     }
  //   }

  //   const data = Object.assign({}, signData, {
  //     [TIMESTAMP]: ts
  //   })
  const signData = {
    [TIMESTAMP]: ts,
  }

  if (isTs) {
    delete signData.timestamp
  }

  if (extraSignPayload) {
    Object.assign(data, extraSignPayload)
  }
  // 不参与验签的数组参数名
  const removeArr = ['defaultMerchantSettle', 'rates', 'merchantAdditional', 'terminals']

  const keys = ['rates']
  const outSignData = {} // 二级
  Object.entries(payload).forEach(([key, val]) => {
    if (
      (typeof val === 'string' && val) ||
      typeof val === 'number' ||
      typeof val === 'boolean' ||
      (Array.isArray(val) && !removeArr.includes(val) && !keys.includes(key))
    ) {
      signData[key] = val
    } else {
      outSignData[key] = val
    }
    // console.log(82, 'signData-->>>', signData)
  })
  //   console.log(56, 'signData-->', signData)
  //   console.log(56, 'outSignData-->', outSignData)

  //   console.log(38, 'data-->', data)

  // sort by ASCLL, order by asc
  const signText = [...Object.keys(signData)]
    .sort()
    .map((key) => {
      if (typeof signData[key] == 'object') {
        return key === TIMESTAMP ? `${TIMESTAMP}=${ts}` : `${key}=${JSON.stringify(signData[key])}`
      }
      return key === TIMESTAMP ? `${TIMESTAMP}=${ts}` : `${key}=${signData[key]}`
    })
    .join('&')

  //   console.log(52, 'signText-->', signText)

  const sign = sm2
    .doSignature(signText, Storage.getStorage('pinia_global').pina_env_var?.SM2_PRIVATE_KEY, {
      hash: true,
      der: true,
    })
    .toUpperCase()

  const headers = {
    [TIMESTAMP]: ts,
    sysOrgCode: Storage.getStorage('pinia_global').pina_env_var?.SYS_ORG_CODE,
    orgCode: Storage.getStorage('pinia_global').pina_env_var?.ORG_CODE,
    sign,
  }

  return {
    headers,
    data: {
      ...signData,
      ...outSignData,
    },
  }
}

export { Decrypt, Encrypt, encryptRequest }
